const globalQueries = {
  footerPromo: `
    footer {
      footerAd {
        image { url }
        logo { url }
        logoSize
        primaryText
        subtext
        destination { webUrl cid }
        accessibilityLabel
        displayAdBadge
        isExternalAffiliate
      }
    }
  `,
  gab: `
    globalAnnouncementBar {
      title
      destination {
        webUrl
        cid
      }
      accessibilityLabel
    }
  `
};

const globalHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Authorization': `Bearer 1099c1c0a613651c486503c8c1b934`,
  'X-Exclude-Invalid': true
};

function fetchGlobalData(callback) {
  const query = `
    {
      ${globalQueries.footerPromo}
      ${globalQueries.gab}
    }
  `;

  fetch('https://graphql.datocms.com/', {
    method: 'POST',
    headers: globalHeaders,
    body: JSON.stringify({ query }),
  })
  .then(res => res.json())
  .then(res => callback(res.data))
  .catch(error => console.log(error));
}

setTimeout(() => {
  if (!window.allowTracking())
    return;
  fetchGlobalData(data => {
    if (typeof initFooterPromo === 'function') {
      initFooterPromo(data.footer);
    }
    if (data.globalAnnouncementBar) {
      initGab(data.globalAnnouncementBar);
    }
  });
}, 500);
